export default __webpack_public_path__ + "static/lycee_logo-53498b5d14f7eb71709891283a6bb0d2.png";